import React from 'react';
import './LegalPages.css';

const Cookies = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>Cookies Policy</h1>
          <p className="subtitle">How DocuAIHub Uses Cookies</p>
          <p className="description">
            This policy explains how we use cookies and similar technologies.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Table of Contents</h3>
            <ul>
              <li><a href="#what-are-cookies">What Are Cookies</a></li>
              <li><a href="#how-we-use">How We Use Cookies</a></li>
              <li><a href="#types">Types of Cookies</a></li>
              <li><a href="#manage">Manage Cookies</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="what-are-cookies" className="content-section">
              <h2>What Are Cookies?</h2>
              <p>
                Cookies are small text files that are placed on your device when you visit a website. 
                They are widely used to make websites work more efficiently and provide information to 
                website owners.
              </p>
              <p>
                Cookies help us understand how you use our site, remember your preferences, and improve 
                your overall experience with DocuAIHub.
              </p>
            </section>

            <section id="how-we-use" className="content-section">
              <h2>How We Use Cookies</h2>
              <p>DocuAIHub uses cookies for the following purposes:</p>
              <ul>
                <li><strong>Essential Functionality:</strong> To enable core features like account login and security</li>
                <li><strong>Performance:</strong> To analyze how our service is used and improve performance</li>
                <li><strong>Preferences:</strong> To remember your settings and preferences</li>
                <li><strong>Security:</strong> To protect against fraudulent activity and enhance security</li>
              </ul>
            </section>

            <section id="types" className="content-section">
              <h2>Types of Cookies We Use</h2>
              
              <h3>Strictly Necessary Cookies</h3>
              <p>
                These cookies are essential for the website to function properly. They enable basic 
                functions like page navigation, access to secure areas, and payment processing.
              </p>
              <p><strong>Examples:</strong> Session cookies, authentication cookies, security cookies</p>

              <h3>Performance Cookies</h3>
              <p>
                These cookies help us understand how visitors interact with our website by collecting 
                and reporting information anonymously. This helps us improve our service.
              </p>
              <p><strong>Examples:</strong> Analytics cookies, usage statistics</p>

              <h3>Functional Cookies</h3>
              <p>
                These cookies enable enhanced functionality and personalization, such as remembering 
                your preferences and settings.
              </p>
              <p><strong>Examples:</strong> Language preferences, display settings, user interface preferences</p>

              <h3>Session vs. Persistent Cookies</h3>
              <p>
                <strong>Session Cookies:</strong> Temporary cookies that are deleted when you close your browser.
              </p>
              <p>
                <strong>Persistent Cookies:</strong> Remain on your device until they expire or you delete them.
              </p>
            </section>

            <section id="manage" className="content-section">
              <h2>How to Manage Cookies</h2>
              <p>
                You have the right to decide whether to accept or reject cookies. Most web browsers 
                automatically accept cookies, but you can modify your browser settings to decline cookies 
                if you prefer.
              </p>

              <h3>Browser Settings</h3>
              <p>You can control and manage cookies through your browser settings:</p>
              <ul>
                <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
                <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
                <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
                <li><strong>Edge:</strong> Settings → Privacy, search, and services → Cookies and site data</li>
              </ul>

              <h3>Impact of Blocking Cookies</h3>
              <p>
                If you choose to block cookies, some features of DocuAIHub may not function properly. 
                Strictly necessary cookies cannot be disabled as they are essential for the service to work.
              </p>
            </section>

            <section className="content-section">
              <h2>Third-Party Cookies</h2>
              <p>
                We may use third-party service providers who set cookies on our website to provide services 
                such as analytics and payment processing. These third parties have their own privacy and 
                cookie policies.
              </p>
              <p>
                We carefully vet all third-party providers to ensure they meet our security and privacy standards.
              </p>
            </section>

            <section className="content-section">
              <h2>Updates to This Policy</h2>
              <p>
                We may update this Cookies Policy from time to time. Any changes will be posted on this 
                page with an updated revision date.
              </p>
            </section>

            <section className="content-section">
              <h2>Contact Us</h2>
              <p>
                If you have questions about our use of cookies, please contact us:
              </p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Phone:</strong> +357 77788373</li>
                <li><strong>Address:</strong> 1 Maiou 3, 2610 Agios Epifanios Oreinis, Cyprus</li>
              </ul>
            </section>

            <section className="content-section">
              <p className="last-updated">Last Updated: February 2026</p>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
